import React, { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';

const UgcCollection = lazy(() =>
    import(/* webpackChunkName: "ugc_collection" */ 'ugc/components/ugcCollections/UgcCollection')
);
const UgcPortfolio = lazy(() =>
    import(/* webpackChunkName: "ugc_portfolio" */ 'ugc/components/ugcPortfolio/UgcPortfolio')
);

export default function Ugc({ match: { path: matchedPath } }) {
    return (
        <Switch>
            <Route path={`${matchedPath}/:serialNo`} component={UgcPortfolio} />
            <Route path={`${matchedPath}`} exact component={UgcCollection} />
        </Switch>
    );
}
